import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getPublicDictionaries } from "../util/wordywhiz";
import DictionaryCard from "./DictionaryCard";
import AdSlot from "../../AdSlot";

function PublicDictionaries() {
  const navigate = useNavigate();
  const [dictionaries, setDictionaries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getPublicDictionaries()
      .then((data) => setDictionaries(data))
      .catch(() => setError("Could not load dictionaries."))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="study-page">
      <div className="study-header">
        <p className="study-eyebrow">Wordy Whiz · Learn</p>
        <h1>Pick a dictionary</h1>
        <p>Flashcard word lists to sharpen your vocabulary.</p>
      </div>

      {isLoading && <div className="dict-spinner" />}
      {error && <p className="dict-state dict-state--error">{error}</p>}
      {!isLoading && !error && dictionaries.length === 0 && (
        <p className="dict-state">No public dictionaries found.</p>
      )}

      <div className="dict-grid">
        {dictionaries.map((dict) => (
          <DictionaryCard
            key={dict.id}
            dict={dict}
            onClick={() => navigate(`/wordy-whiz/dictionary/${dict.id}`)}
          />
        ))}
      </div>

      <AdSlot slot={process.env.REACT_APP_ADSENSE_SLOT_DICTIONARIES} className="mt-4" />
    </div>
  );
}

export default PublicDictionaries;
